export const DASHBOARD_VISIBLE_CARDS = {
  jobsCount: [
    'total',
    'Total Jobs',
    'active',
    'Active Jobs',
    'myAssignedCount',
    'My Jobs',
  ],
  submissionCount: [
    'Under Evaluation',
    'pending',
    'Pending',
    'submittedToClientCount',
    'Submitted to Client',
    'rejectedSubmissionCount',
    'Rejected',
  ],
  // onboardingCount: [
  //   'inProgress',
  //   'In Progress',
  //   'hired',
  //   'Hired',
  //   'projectCompleted',
  //   'Project Completed',
  //   'archive',
  //   'Archive',
  // ],
};

export function visibleCardsFor(moduleName) {
  return DASHBOARD_VISIBLE_CARDS[moduleName] ?? null;
}
